import React from "react";
import { Link } from "react-router-dom";
import { homePageV2Stories } from "../content/homePageV2Content";

export function StoriesSectionV2() {
  const { cards, link } = homePageV2Stories;

  return (
    <section className="mh2v2-stories mh2v2-section-mustard" id="resources">
      <div className="mh2v2-container">
        <h3 className="mh2v2-section-title mh2v2-section-title--center">
          FEATURED STORIES &amp; CONVERSATIONS
        </h3>
        <div className="mh2v2-story-grid">
          {/* TODO: homepage CMS / featured content API */}
          {cards.map((card) => (
            <article className="mh2v2-story-card" key={card.title}>
              <img src={card.image} alt={card.title} />
              <div className="mh2v2-story-card__content">
                <p>{card.title}</p>
                <Link to={card.to} className="mh2v2-inline-btn">
                  {card.action} <span>→</span>
                </Link>
              </div>
            </article>
          ))}
        </div>
        <Link className="mh2v2-link-row" to={link.to}>
          {link.label} →
        </Link>
      </div>
    </section>
  );
}

export default StoriesSectionV2;
